import Decimal from "break_infinity.js";
import { Game } from "../types/game";

export function saveObjectToLocalStorage(key: string, object: any) {
  const json = JSON.stringify(object);
  localStorage.setItem(key, json);
}

export function saveGameInLocalStorage(game: any) {
  saveObjectToLocalStorage("game", game);
  console.log("Game saved locally");
}

export function loadGameFromLocalStorage() {
  let game = loadObjectFromLocalStorage("game");
  if (game === null) return null;
  game.unlockedAchievementIds = new Set<number>(game.unlockedAchievementIds);
  game.producers = game.producers.map((producer: any) => ({
    ...producer,
    value: new Decimal(producer.value),
  }));
  game.molecule = {
    ...game.molecule,
    value: new Decimal(game.molecule.value),
  };
  game.last10MoleculeCreations = game.last10MoleculeCreations.map(
    (creation: any) => ({
      ...creation,
      molecules: new Decimal(creation.molecules),
    })
  );
  return game as Game;
}

export function loadObjectFromLocalStorage(key: string) {
  const json = localStorage.getItem(key);
  if (json === null) return null;
  return JSON.parse(json);
}

export function deleteLocalSaveFile() {
  localStorage.clear();
}
